var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import startCase from 'lodash.startcase';
import useDesign from '../../../../../../../hooks/useDesign';
import { TranslatedText } from '../../../../../../atoms/TranslatedText';
import { Grantor, StatusValue, StatusWrapper, Wrapper } from './styles';
export var Header = function (_a) {
    var design = _a.design, values = _a.values, t = _a.translations;
    var schema = useDesign(design).schema;
    var status = values.status, grantorName = values.grantorName;
    return (_jsxs(Wrapper, __assign({ schema: schema, "data-design": design, className: "incentive__header" }, { children: [_jsx(Grantor, __assign({ className: "incentive__header__grantor" }, { children: grantorName })), _jsxs(StatusWrapper, __assign({ className: "incentive__header__status" }, { children: [_jsx(TranslatedText, { className: "incentive__header__status__text", i18n: t.status }), ' / ', _jsx(StatusValue, __assign({ className: "incentive__header__status__value", color: status.color }, { children: startCase(status.text) }))] }))] })));
};
